<div *ngIf="loading" class="custom-loader-overlay">
    <div class="custom-loader-container">
        <div class="custom-loader"></div>
        <div class="loader-message">
            <div>{{ loaderMessageLine1 }}</div>
            <div>{{ loaderMessageLine2 }}</div>
        </div>
    </div>
</div>
<div *ngIf="loading && apiError" class="custom-loader-overlay">
    <div class="custom-loader-container">
        <div class="custom-loader"></div>
        <div class="loader-message">Some lines failed to submit. Please try again.</div>
    </div>
</div>

<!-- Main container with consistent horizontal padding -->
<div class="w-full px-2 max-w-[2000px] mx-auto">
    <!-- Toolbar -->
    <!-- <div class="mb-8 mt-8 text-[16px]">
        <div class="sticky-toolbar">
            <p-toolbar styleClass="mb-6 text-[16px]">
                <ng-template #stFart>
                    <p-button label="Submit" icon="pi pi-check" severity="secondary" class="mr-2" (onClick)="submitOrder()"></p-button>
                    <p-button label="Generate Invoice" icon="pi pi-file" class="mr-2" severity="secondary" (onClick)="generateInvoice()"></p-button>
                    <p-button label="Export to Mail" icon="pi pi-envelope" severity="secondary" class="mr-2" (onClick)="exportToMail()"></p-button>
                    <p-button label="Picking List" icon="pi pi-list" severity="secondary" (onClick)="openPickingList()"></p-button>
                </ng-template>
                <ng-template #end>
                    <p-button label="Sync" icon="pi pi-sync" severity="secondary" class="mr-2" (onClick)="syncData()"></p-button>

                    <p-button label="Export" icon="pi pi-upload" severity="secondary" (onClick)="exportCSV()"></p-button>
                    <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" class="mr-2" (onClick)="goBack()"></p-button>
                </ng-template>
            </p-toolbar>
        </div>
    </div> -->
    <!-- Sticky Toolbar Wrapper -->
    <div class="sticky-toolbar mb-8 text-[14px]">
        <p-toolbar class="text-[14px] p-0">
            <ng-template pTemplate="start">
                <div class="left-buttons flex flex-wrap gap-2">
                    <p-button 
    [label]="saveOrderButtonLabel"
    *ngIf="!readOnly && !isReadOnly" 
    icon="pi pi-check" 
    severity="secondary" 
    (onClick)="submitOrder()"
    [disabled]="isTableInEditMode || loading || orderSaveInFlight || isSaveBlockedByStock"
    [pTooltip]="saveButtonStockBlockTooltip"
    tooltipPosition="top"
></p-button>
                    <p-button
                        label="Browse Item"
                        icon="pi pi-search"
                        severity="secondary"
                        (onClick)="openItemBrowsePopup()"
                        [disabled]="!canOpenItemBrowsePopup"
                        [pTooltip]="itemBrowseTooltip"
                        tooltipPosition="top"
                    ></p-button>
                    <p-button
                        label="Price history"
                        icon="pi pi-history"
                        severity="secondary"
                        (onClick)="openOldSalesPricePopup()"
                        [disabled]="!oldSalesPriceCustomer"
                        [pTooltip]="oldSalesPriceCustomer ? 'See price history for this customer' : 'Select a customer first'"
                        tooltipPosition="top"
                    ></p-button>
                    <!-- <p-button label="Invoice" icon="pi pi-file" severity="secondary" (onClick)="generateInvoice()" [disabled]="!item.orderNumber || item.orderNumber === 'New Order'"> </p-button> -->
                    <p-button  *ngIf="showPickingListButton" label="Picking List" icon="pi pi-list" severity="secondary" (onClick)="openPickingList()" [disabled]="!item.orderNumber || item.orderNumber === 'New Order'"> </p-button>
                    <p-button
                        *ngIf="(isReadOnly && item.orderMovingStatus === 'INV') || !isReadOnly"
                        label="Invoice"
                        icon="pi pi-file"
                        severity="secondary"
                        (onClick)="showInvoiceConfirm()"
                        [disabled]="!canGenerateInvoiceForOrder()"
                        [pTooltip]="getInvoiceTooltip()"
                        tooltipPosition="top"
                    >
                    </p-button>
                    <p-button *ngIf="isManagerOrSuperUser" label="AR Statements" icon="pi pi-envelope" severity="secondary" class="mr-2" (onClick)="openARStatementDialog()" />
                    <!-- <p-button label="Export to Mail" icon="pi pi-envelope" severity="secondary" (onClick)="exportToMail()"></p-button> -->
                </div>
            </ng-template>

            <ng-template pTemplate="end">
                <div class="right-buttons flex flex-wrap gap-2">
                    <!-- <p-button label="Sync" icon="pi pi-sync" severity="secondary" (onClick)="syncData()"></p-button> -->
                    <!-- <p-button label="Export" icon="pi pi-upload" severity="secondary" (onClick)="exportCSV()"></p-button> -->
                    <p-button label="Back" icon="pi pi-arrow-left" severity="secondary" (onClick)="goBack()"></p-button>
                </div>
            </ng-template>
        </p-toolbar>
    </div>

    <div *ngIf="isCreditNoteOrder" class="credit-note-banner w-full mb-4" role="alert">
        CREDIT NOTE ORDER — quantities will be recorded as negative returns.
    </div>

    <div *ngIf="creditLimitApprovalBanner as appr" class="credit-limit-approved-banner mb-4" role="status" aria-live="polite">
        <div class="credit-limit-exceeded-banner__title">
            <i class="pi pi-check-circle" aria-hidden="true"></i>
            <span>Credit Limit Approved</span>
        </div>
        <p class="margin-violation-banner__text">
            Approved by <strong>{{ appr.approvedBy }}</strong>
            <span *ngIf="appr.approvedAt && appr.approvedAt !== '—'"> on {{ appr.approvedAt }}</span>.
            Reason: {{ appr.reason }}
        </p>
    </div>

    <div *ngIf="marginApprovalBanner as mappr" class="credit-limit-approved-banner mb-4" role="status" aria-live="polite">
        <div class="credit-limit-exceeded-banner__title">
            <i class="pi pi-check-circle" aria-hidden="true"></i>
            <span>Margin Approved</span>
        </div>
        <p class="margin-violation-banner__text">
            Approved by <strong>{{ mappr.approvedBy }}</strong>
            <span *ngIf="mappr.approvedAt && mappr.approvedAt !== '—'"> on {{ mappr.approvedAt }}</span>.
            Reason: {{ mappr.reason }}
        </p>
    </div>

    <div *ngIf="overdueRestrictionBanner as od" class="credit-limit-exceeded-banner mb-4" role="alert" aria-live="polite">
        <div class="credit-limit-exceeded-banner__title">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Overdue Days (Credit Limit 4)</span>
        </div>
        <div class="credit-limit-exceeded-banner__metrics">
            <div class="credit-limit-exceeded-banner__metric">
                <i class="pi pi-calendar" aria-hidden="true"></i>
                <span>Overdue days: <strong>{{ od.nood }}</strong> / limit <strong>{{ od.odud }}</strong></span>
            </div>
        </div>
    </div>

    <div *ngIf="showMarginViolationBanner" class="margin-violation-banner mb-4" role="alert" aria-live="polite">
        <div class="margin-violation-banner__title">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <span>Contribution Margin Below Minimum</span>
        </div>
        <p class="margin-violation-banner__text">
            {{ marginViolationLineCount }} line(s) are below the minimum required threshold. Saving or proceeding may require approver review.
        </p>
    </div>

    <div *ngIf="creditExposureBanner as exp" class="credit-limit-exceeded-banner mb-4" role="alert" aria-live="polite">
        <div class="credit-limit-exceeded-banner__title">
            <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
            <span>Credit Limit Exceeded</span>
        </div>
        <div class="credit-limit-exceeded-banner__metrics">
            <div class="credit-limit-exceeded-banner__metric">
                <i class="pi pi-wallet" aria-hidden="true"></i>
                <span>Outstanding: <strong>{{ exp.outstanding | number: '1.2-2' }}</strong></span>
            </div>
            <span class="credit-limit-exceeded-banner__divider" aria-hidden="true"></span>
            <div class="credit-limit-exceeded-banner__metric">
                <i class="pi pi-shopping-cart" aria-hidden="true"></i>
                <span>Order value: <strong>{{ exp.orderValue | number: '1.2-2' }}</strong></span>
            </div>
            <span class="credit-limit-exceeded-banner__divider" aria-hidden="true"></span>
            <div class="credit-limit-exceeded-banner__metric">
                <i class="pi pi-credit-card" aria-hidden="true"></i>
                <span>Credit limit: <strong>{{ exp.creditLimit3 | number: '1.2-2' }}</strong></span>
            </div>
            <span class="credit-limit-exceeded-banner__divider" aria-hidden="true"></span>
            <div class="credit-limit-exceeded-banner__metric">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Exceeded by: <strong>{{ exp.exceedBy | number: '1.2-2' }}</strong></span>
            </div>
        </div>
    </div>

    <div class="w-full mb-8 rounded-xl border shadow font-sans">
        <button
            type="button"
            class="flex items-center gap-2 text-xll font-bold text-primary w-full text-left px-6 py-4 border-b focus:outline-none"
            (click)="toggleHeaderPanel()"
            [attr.aria-expanded]="headerPanelOpen"
            aria-controls="headerPanelSection"
        >
            <i class="pi" [ngClass]="headerPanelOpen ? 'pi-minus-circle' : 'pi-plus-circle'"></i>
            Header
        </button>
        <div *ngIf="headerPanelOpen" id="headerPanelSection" class="px-6 py-6">
            <app-header-info [item]="item" [product]="product" [readOnly]="readOnly" [company]="company" [division]="division" [isReadOnly]="isReadOnly" [orderTypeOptions]="orderTypesForHeader" (addressChanged)="onHeaderAddressChanged()"></app-header-info>
        </div>
    </div>

    <!-- Add Item Details Section (Collapsible) -->
    <div class="w-full mb-4" *ngIf="!readOnly && !isReadOnly">
        <div class="w-full flex flex-col gap-1 text-[16px] rounded-xl border p-0 shadow font-sans">
            <button type="button" class="flex items-center gap-2 text-xll font-bold text-primary w-fit text-left px-6 py-4 focus:outline-none" (click)="toggleAddItemForm()" [attr.aria-expanded]="showAddItemForm" aria-controls="addItemFormSection">
                <i class="pi" [ngClass]="showAddItemForm ? 'pi-minus-circle' : 'pi-plus-circle'"></i>
                Add Item Details
            </button>
            <div *ngIf="showAddItemForm" id="addItemFormSection" class="flex flex-wrap gap-6 mb-6 px-6">
                <!-- Add Item Form -->
                <form class="flex flex-wrap gap-6" style="flex: 2 1 0%" (keydown)="onFormKeyDown($event)">
                    <!-- Line Number (Readonly) -->
                    <div class="flex flex-col ml-4">
                        <label class="mb-1 font-medium" for="lineNumber">Line No.</label>
                        <input id="lineNumber" pInputText [(ngModel)]="itemForm.lineNumber" name="lineNumber" class="p-inputtext p-component w-[50px]" disabled />
                    </div>

                    <!-- Item Name -->
                    <!-- Item Name -->
                    <div class="flex flex-col w-[400px] min-w-[220px]">
                        <label class="mb-1 font-medium" for="itemName">Item</label>
                        <p-autoComplete
                            #itemNameInput
                            [(ngModel)]="itemForm.FINALRESPNSE"
                            [suggestions]="filteredItemNames"
                            (completeMethod)="filterItemNames($event)"
                            [dropdown]="true"
                            [forceSelection]="true"
                            placeholder="Search Item"
                            name="itemName"
                            id="itemName"
                            field="FINALRESPNSE"
                            [panelStyle]="{ width: '550px' }"
                            styleClass="w-full"
                            (onSelect)="onItemNameSelect($event)"
                            (keydown.enter)="quantityInput.focus()"
                            (input)="onItemNameInputChange($event)"
                        ></p-autoComplete>
                        <p-message *ngIf="errorMessages.itemName" severity="error" text="{{ errorMessages.itemName }}"></p-message>
                    </div>
                    <!-- (onBlur)="onItemNumberChange()" -->
                    <!-- Item Number -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="itemNumber">Item No.</label>
                        <p-autoComplete
                            #itemNumberInput
                            [(ngModel)]="itemForm.itemNumber"
                            [suggestions]="filteredItemNumbers"
                            (completeMethod)="filterItemNumber($event)"
                            [dropdown]="true"
                            [forceSelection]="true"
                            placeholder="Search Item"
                            name="itemNumber"
                            id="itemNumber"
                            field="MBITNO"
                            (onSelect)="onItemNumberSelect($event)"
                            (keydown.enter)="quantityInput.focus()"
                            (input)="onItemNumberInputChange($event)"
                        ></p-autoComplete>
                        <p-message *ngIf="errorMessages.itemno" severity="error" text="{{ errorMessages.itemno }} "></p-message>
                    </div>

                    <!-- Quantity -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="quantity">Qty</label>
                        <input
                            id="quantity"
                            pInputText
                            [(ngModel)]="itemForm.quantity"
                            #quantityRef="ngModel"
                            required
                            type="text"
                            inputmode="decimal"
                            autocomplete="off"
                            name="quantity"
                            class="p-inputtext p-component w-[80px]"
                            #quantityInput
                            (keydown.enter)="onQuantityEnter(); rateInput.focus()"
                            (focus)="selectAll($event)"
                            (input)="restrictDecimals($event, 'quantity')"
                        />
                        <p-message *ngIf="errorMessages.quantity" severity="error" text="{{ errorMessages.quantity }}"></p-message>
                    </div>
                    <!-- Rate -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="rate">Rate</label>
                        <input
                            id="rate"
                            pInputText
                            [(ngModel)]="itemForm.rate"
                            #rateRef="ngModel"
                            required
                            type="text"
                            inputmode="decimal"
                            autocomplete="off"
                            name="rate"
                            class="p-inputtext p-component w-[100px]"
                            #rateInput
                            (blur)="onRateEnter()"
                            (keydown.enter)="onRateEnter()"
                            (focus)="selectAll($event)"
                            (input)="restrictDecimals($event, 'rate')"
                        />
                        <p-message *ngIf="errorMessages.rate" severity="error" text="{{ errorMessages.rate }}"></p-message>
                    </div>
                    <!-- Amt (Readonly) -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="amount">Gross Amt</label>
                        <input id="amount" pInputText [(ngModel)]="itemForm.amount" step="0.01" type="number" name="amount" class="p-inputtext p-component w-[120px] bg-gray-100 dark:bg-gray-800 dark:text-gray-100" readonly disabled />
                    </div>

                    <!-- Discount -->
                    <div class="flex flex-col" *ngIf="division !== '400'">
                        <label class="mb-1 font-medium" for="discount">Disc %</label>
                        <input
                            id="discount"
                            pInputText
                            [(ngModel)]="itemForm.discount"
                            #discountRef="ngModel"
                            type="text"
                            inputmode="decimal"
                            autocomplete="off"
                            name="discount"
                            class="p-inputtext p-component w-[70px]"
                            #discountInput
                            (input)="restrictDecimals($event, 'discount')"
                            (blur)="onDiscountEnter()"
                            (focus)="selectAll($event)"
                            (keydown.enter)="onDiscountEnter()"
                        />
                        <p-message *ngIf="errorMessages.discount" severity="error" text="{{ errorMessages.discount }}"></p-message>
                    </div>
                    <!-- Amt After Disc (Readonly) -->
                    <div class="flex flex-col" *ngIf="division !== '400'">
                        <label class="mb-1 font-medium" for="amountAfterDiscount">Net Amount</label>
                        <input
                            id="amountAfterDiscount"
                            pInputText
                            [(ngModel)]="itemForm.amountAfterDiscount"
                            type="number"
                            name="amountAfterDiscount"
                            class="p-inputtext p-component w-[120px] bg-gray-100 dark:bg-gray-800 dark:text-gray-100"
                            readonly
                            disabled
                        />
                    </div>
                    <!-- VAT -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="vat">VAT %</label>
                        <input
                            id="vat"
                            pInputText
                            [(ngModel)]="itemForm.vat"
                            name="vat"
                            type="number"
                            #vatInput
                            (keydown.enter)="onVatChange(); focusSubmitBtn()"
                            (focus)="selectAll($event)"
                            class="p-inputtext p-component w-[60px] bg-gray-100 dark:bg-gray-800 dark:text-gray-100"
                            disabled
                        />

                        <p-message *ngIf="errorMessages.vat" severity="error" text="{{ errorMessages.vat }}"></p-message>
                    </div>
                    <!-- VAT Amount -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="vatAmount">VAT Amount</label>
                        <input id="vatAmount" pInputText [(ngModel)]="itemForm.vatAmount" type="number" name="vatAmount" class="p-inputtext p-component w-[120px] bg-gray-100 dark:bg-gray-800 dark:text-gray-100" readonly disabled />
                    </div>
                    <!-- Amt After VAT (Readonly) -->
                    <div class="flex flex-col">
                        <label class="mb-1 font-medium" for="amountAfterVat">Line Amount</label>
                        <input id="amountAfterVat" pInputText [(ngModel)]="itemForm.amountAfterVat" type="number" name="amountAfterVat" class="p-inputtext p-component w-[120px] bg-gray-100 dark:bg-gray-800 dark:text-gray-100" readonly disabled />
                    </div>

                    <!-- Buttons -->
                    <div class="flex gap-2 mt-4">
                        <button
                            #submitBtnRef
                            pButton
                            label="Submit"
                            (click)="submitItem()"
                            *ngIf="!isEditing"
                            type="button"
                            [ngClass]="{ 'p-button-outlined': !isFocused }"
                            (focus)="isFocused = true"
                            (blur)="isFocused = false"
                            (mouseenter)="isFocused = true"
                            (mouseleave)="isFocused = false"
                        ></button>

                        <!-- <button #updateBtnRef pButton label="Update" icon="pi pi-check" (click)="updateItem()" *ngIf="isEditing" type="button"></button>
                        <p-button label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="cancelEdit()" *ngIf="isEditing"></p-button> -->
                        <button pButton label="Clear" severity="secondary" icon="pi pi-filter-slash" (click)="clearItemForm()" type="button"></button>
                        <p-toast />
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="w-full mb-8" *ngIf="!readOnly && !isReadOnly">
        <div class="w-full flex flex-col gap-1 text-[14px] rounded-xl border p-0 shadow font-sans">
            <button
                type="button"
                class="flex items-center gap-2 text-xll font-bold text-primary w-fit text-left px-6 py-4 focus:outline-none"
                (click)="showInfoSection = !showInfoSection"
                [attr.aria-expanded]="showInfoSection"
                aria-controls="infoSection"
            >
                <i class="pi" [ngClass]="showInfoSection ? 'pi-minus-circle' : 'pi-plus-circle'"></i>
                Item Info
            </button>
            <div *ngIf="showInfoSection" id="infoSection" class="flex flex-col md:flex-row gap-4 ml-3 mt-1 pb-2 w-full">
                <!-- Available Qty -->
                <div class="flex-[1] flex flex-col rounded-xl border p-6 text-[14px] shadow font-sans min-w-[120px]">
                    <h3 class="text-[14px] text-base font-semibold text-primary mb-2 border-b pb-1 flex items-center gap-2"><i class="pi pi-box"></i> Available Qty</h3>
                    <div class="flex flex-row gap-8 flex-wrap">
                        <span *ngFor="let w of warehouses">
                            <span class="font-medium">{{ w.name }} {{ this.item.whsId }}:</span> {{ w.qty }}
                        </span>
                    </div>
                </div>
                <!-- Price List Indicator -->
                <div class="flex-[1.5] flex flex-col rounded-xl border p-6 text-[14px] shadow font-sans min-w-[120px]">
                    <h3 class="text-[14px] text-base font-semibold text-primary mb-2 border-b pb-1 flex items-center gap-2"><i class="pi pi-tag"></i> Price List Indicator</h3>
                    <div class="flex flex-row gap-14">
                        <span *ngFor="let pl of priceLists">
                            <!-- <span class="font-medium">{{ pl.name }}:</span> {{ pl.value }} -->
                            <span class="font-medium">{{ pl.name }}:</span> {{ pl.value | number: '1.2-2' }}
                        </span>
                    </div>
                </div>
                <!-- Info -->
                <div class="flex-[2] flex flex-col rounded-xl border p-6 shadow font-sans min-w-[200px] mr-6">
                    <h3 class="text-base font-semibold text-primary mb-2 border-b pb-1 flex items-center gap-2"><i class="pi pi-info-circle"></i> Info</h3>
                    <div class="flex flex-row gap-10 flex-wrap">
                        <!-- <span><span class="font-medium">Last Invoiced Rate:</span> </span> -->
                        <!-- <span><span class="font-medium">Cost Price:</span> {{ info.costPrice }}</span> -->
                        <span>
                            <span class="font-medium">Last Sales Price:</span>
                            {{ info.lastSalePrice | number: '1.2-4' }}
                        </span>
                        <span>
                            <span class="font-medium">Earliest Expiry Date:</span>
                            {{ info.expiryDate }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="w-full">
        <app-item-table
            [itemList]="itemList"
            [readOnly]="readOnly"
            [isReadOnly]="isReadOnly"
            [isCreditNoteOrder]="isCreditNoteOrder"
            [company]="company"
            [division]="division"
            [warehouse]="warehouse"
            [customerId]="item?.customerId || item?.customer || ''"
            [defaultPriceList]="product?.defaultPriceList || item?.defaultPriceList || ''"
            [orderNumber]="item?.orderNumber || ''"
            [orderStatus]="item?.status"
            [orderMovingStatus]="item?.orderMovingStatus || ''"
            (itemListChange)="onItemListChange($event)"
            (summaryChange)="onSummaryChange($event)"
            (rateBlur)="onRateBlurFromChild($event)"
            (discountBlur)="onDiscountBlurFromChild($event)"
            (deleteItemEvent)="onDeleteItem($event)"
            (editingStateChange)="onEditingStateChange($event)"
            (marginValidationFailed)="onLineMarginValidationFailed($event)"
            [isManagerOrSuperUser]="isManagerOrSuperUser"
            [deletedItems]="deletedItems"
        >
        </app-item-table>
    </div>

    <app-item-browse-popup
        [visible]="showItemBrowsePopup"
        (visibleChange)="showItemBrowsePopup = $event"
        [searchText]="itemBrowseSearch"
        (searchTextChange)="itemBrowseSearch = $event"
        [selectedRow]="selectedBrowseRow"
        [cono]="company"
        [divi]="division"
        [warehouse]="warehouse"
        [itemList]="itemList"
        (rowSelected)="onBrowseRowSelected($event)"
        (selected)="onBrowseSelect($event)"
    ></app-item-browse-popup>

    <app-old-sales-price-popup
        [visible]="showOldSalesPricePopup"
        (visibleChange)="showOldSalesPricePopup = $event"
        [customer]="oldSalesPriceCustomer"
        [division]="oldSalesPriceDivision"
        [warehouse]="oldSalesPriceWarehouse"
        [company]="company"
        [itemNo]="oldSalesPriceItemNo"
    ></app-old-sales-price-popup>

    <p-dialog
        *ngIf="showMissingCustomerBanner"
        [visible]="true"
        [modal]="true"
        [closable]="false"
        [closeOnEscape]="false"
        [dismissableMask]="false"
        [draggable]="false"
        [resizable]="false"
        [style]="{ width: '28rem', maxWidth: '95vw' }"
        header="Customer Required"
    >
        <ng-template pTemplate="content">
            <div class="text-center">
                <i class="pi pi-exclamation-triangle text-4xl text-orange-500 mb-3" aria-hidden="true"></i>
                <p class="m-0 text-base leading-relaxed">
                    Customer number is missing for this order. You cannot add lines or save here.
                    Go back to Manage Orders, select the customer again, then start the order.
                </p>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <p-button label="Back" icon="pi pi-arrow-left" (onClick)="onMissingCustomerGoBack()"></p-button>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="creditLimitDialogVisible"
        [modal]="true"
        [style]="{ width: '26rem' }"
        styleClass="credit-limit-dialog"
        [closable]="true"
        (onHide)="onCreditLimitConfirmCancel()"
    >
        <ng-template pTemplate="header">
            <span *ngIf="creditLimitDialogKind === 'overdue'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Overdue Balance</span>
            </span>
            <span *ngIf="creditLimitDialogKind === 'both'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Credit Limit 3 &amp; 4 Exceeded</span>
            </span>
            <span *ngIf="creditLimitDialogKind === 'exposure'" class="credit-limit-dialog-header credit-limit-dialog-header--warning">
                <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
                <span>Credit Limit Warning</span>
            </span>
        </ng-template>
        <app-credit-limit-dialog-content
            [kind]="creditLimitDialogKind"
            [data]="creditLimitDialogData"
            [nood]="creditLimitDialogNood"
            [odud]="creditLimitDialogOdud"
            [note]="creditLimitSaveNote"
        ></app-credit-limit-dialog-content>
        <ng-template pTemplate="footer">
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" (onClick)="onCreditLimitConfirmCancel()"></p-button>
            <p-button label="Yes, Save" icon="pi pi-check" (onClick)="onCreditLimitConfirmAccept()"></p-button>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="creditLimitProceedDialogVisible"
        [modal]="true"
        [style]="{ width: '26rem' }"
        styleClass="credit-limit-dialog"
        [closable]="true"
        (onHide)="onCreditLimitProceedCancel()"
    >
        <ng-template pTemplate="header">
            <span *ngIf="creditLimitDialogKind === 'overdue'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Overdue Balance</span>
            </span>
            <span *ngIf="creditLimitDialogKind === 'both'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Credit Limit 3 &amp; 4 Exceeded</span>
            </span>
            <span *ngIf="creditLimitDialogKind === 'exposure'" class="credit-limit-dialog-header credit-limit-dialog-header--warning">
                <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
                <span>Credit Limit Warning</span>
            </span>
        </ng-template>
        <app-credit-limit-dialog-content
            [kind]="creditLimitDialogKind"
            [data]="creditLimitDialogData"
            [nood]="creditLimitDialogNood"
            [odud]="creditLimitDialogOdud"
            [note]="creditLimitProceedNote"
        ></app-credit-limit-dialog-content>
        <div *ngIf="creditLimitProceedBypassAction === 'sync'" class="credit-limit-approval-reason mt-3">
            <label for="creditLimitApprovalReason" class="block mb-2 font-medium">Approval reason (required)</label>
            <textarea
                id="creditLimitApprovalReason"
                pTextarea
                rows="3"
                class="w-full"
                [(ngModel)]="creditLimitApprovalReason"
                [disabled]="creditLimitApprovalSubmitting"
                placeholder="Enter reason for releasing credit restriction"
            ></textarea>
            <small class="text-color-secondary">Minimum 5 characters.</small>
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" [disabled]="creditLimitApprovalSubmitting" (onClick)="onCreditLimitProceedCancel()"></p-button>
            <p-button
                [label]="creditLimitProceedBypassAction === 'sync' ? 'Approve &amp; Continue' : creditLimitProceedLabel"
                icon="pi pi-arrow-right"
                [loading]="creditLimitApprovalSubmitting"
                [disabled]="creditLimitProceedBypassAction === 'sync' && !canSubmitCreditLimitApproval"
                (onClick)="onCreditLimitProceedAccept()"
            ></p-button>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="creditLimitBlockedDialogVisible"
        [modal]="true"
        [style]="{ width: '26rem' }"
        styleClass="credit-limit-dialog"
        [closable]="true"
        (onHide)="onCreditLimitBlockedDialogClose()"
    >
        <ng-template pTemplate="header">
            <span *ngIf="creditLimitDialogKind === 'overdue'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Overdue Balance</span>
            </span>
            <span *ngIf="creditLimitDialogKind === 'both'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Credit Limit 3 &amp; 4 Exceeded</span>
            </span>
            <span *ngIf="creditLimitDialogKind === 'exposure'" class="credit-limit-dialog-header credit-limit-dialog-header--exceeded">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Credit Limit Exceeded</span>
            </span>
        </ng-template>
        <app-credit-limit-dialog-content
            [kind]="creditLimitDialogKind"
            [data]="creditLimitDialogData"
            [nood]="creditLimitDialogNood"
            [odud]="creditLimitDialogOdud"
            [note]="creditLimitBlockedNote"
        ></app-credit-limit-dialog-content>
        <ng-template pTemplate="footer">
            <p-button label="OK" icon="pi pi-check" (onClick)="onCreditLimitBlockedDialogClose()"></p-button>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="marginItemWarningDialogVisible"
        [style]="{ width: '440px', maxWidth: '95vw' }"
        styleClass="margin-validation-dialog margin-item-warning-dialog"
        [modal]="true"
        [closable]="true"
        (onHide)="onMarginItemWarningDialogClose()"
    >
        <ng-template pTemplate="header">
            <span class="margin-dialog-header">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Margin Below Minimum</span>
            </span>
        </ng-template>
        <app-margin-approval-dialog-content
            mode="item-warning"
            [itemName]="marginItemWarningItemName"
            [actualMargin]="marginItemWarningActual"
            [requiredMargin]="marginItemWarningRequired"
        ></app-margin-approval-dialog-content>
        <ng-template pTemplate="footer">
            <p-button
                label="OK"
                icon="pi pi-check"
                styleClass="margin-dialog-ok-btn"
                (onClick)="onMarginItemWarningDialogClose()"
            ></p-button>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="marginApprovalProceedDialogVisible"
        [style]="{ width: '440px', maxWidth: '95vw' }"
        styleClass="margin-validation-dialog margin-approval-dialog"
        [modal]="true"
        [closable]="true"
        (onHide)="onMarginApprovalProceedCancel()"
    >
        <ng-template pTemplate="header">
            <span class="margin-dialog-header">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Margin Approval Required</span>
            </span>
        </ng-template>
        <app-margin-approval-dialog-content
            mode="approval"
            [failingLines]="marginApprovalSummary?.failingLines ?? []"
            [orderViolation]="marginApprovalSummary?.orderViolation ?? null"
            [note]="marginApprovalContactNote"
            [contactEmails]="marginApprovalContactEmails"
            [proceedActionLabel]="marginApprovalProceedLabel"
            [proceedNote]="marginApprovalProceedNote"
        ></app-margin-approval-dialog-content>
        <div *ngIf="marginApprovalProceedNeedsApi" class="credit-limit-approval-reason mt-3">
            <label for="marginApprovalReason" class="block mb-2 font-medium">Approval reason (required)</label>
            <textarea
                id="marginApprovalReason"
                pTextarea
                rows="3"
                class="w-full"
                [(ngModel)]="marginApprovalReason"
                [disabled]="marginApprovalSubmitting"
                placeholder="Enter reason for approving margin exception"
            ></textarea>
            <small class="text-color-secondary">Minimum 5 characters.</small>
        </div>
        <ng-template pTemplate="footer">
            <p-button label="Cancel" icon="pi pi-times" severity="secondary" [disabled]="marginApprovalSubmitting" (onClick)="onMarginApprovalProceedCancel()"></p-button>
            <p-button
                [label]="marginApprovalProceedLabel"
                icon="pi pi-check"
                styleClass="margin-dialog-ok-btn"
                [loading]="marginApprovalSubmitting"
                [disabled]="marginApprovalProceedNeedsApi && !canSubmitMarginApproval"
                (onClick)="onMarginApprovalProceedAccept()"
            ></p-button>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="marginApprovalBlockedDialogVisible"
        [style]="{ width: '440px', maxWidth: '95vw' }"
        styleClass="margin-validation-dialog margin-blocked-approval-dialog"
        [modal]="true"
        [closable]="true"
        (onHide)="onMarginApprovalBlockedDialogDismiss()"
    >
        <ng-template pTemplate="header">
            <span class="margin-dialog-header">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Approval Required</span>
            </span>
        </ng-template>
        <app-margin-approval-dialog-content
            mode="blocked"
            [failingLines]="marginApprovalSummary?.failingLines ?? []"
            [orderViolation]="marginApprovalSummary?.orderViolation ?? null"
            [note]="marginApprovalContactNote"
            [contactEmails]="marginApprovalContactEmails"
            [blockedApprovalNotice]="marginApprovalBlockedNotice"
        ></app-margin-approval-dialog-content>
        <ng-template pTemplate="footer">
            <p-button
                label="OK"
                icon="pi pi-check"
                styleClass="margin-dialog-ok-btn"
                (onClick)="onMarginApprovalBlockedDialogOk()"
            ></p-button>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="orderMarginDialogVisible"
        [style]="{ width: '400px' }"
        styleClass="margin-validation-dialog"
        [modal]="true"
        [closable]="true"
        (onHide)="onOrderMarginDialogClose()"
    >
        <ng-template pTemplate="header">
            <span class="margin-dialog-header">
                <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                <span>Cannot Save Order</span>
            </span>
        </ng-template>
        <app-margin-dialog-content
            kind="order"
            [actualMargin]="orderMarginDialogActual"
            [requiredMargin]="orderMarginDialogRequired"
        ></app-margin-dialog-content>
        <ng-template pTemplate="footer">
            <p-button
                label="OK"
                icon="pi pi-check"
                styleClass="margin-dialog-ok-btn"
                (onClick)="onOrderMarginDialogClose()"
            ></p-button>
        </ng-template>
    </p-dialog>

    <!-- Confirmation Dialog -->
    <p-dialog [(visible)]="confirmDialogVisible" [style]="{ width: '450px' }" header="Confirm Submission" [modal]="true">
        <ng-template #content>
            <div class="text-center">
                <p>Are you sure you want to submit the header and lines?</p>
            </div>
        </ng-template>
        <ng-template #footer>
            <!-- <p-button label="Cancel" icon="pi pi-times" text (click)="confirmDialogVisible = false" /> -->
            <p-button label="Submit" icon="pi pi-check" (click)="submitOrder(); confirmDialogVisible = false" [disabled]="loading || orderSaveInFlight || isSaveBlockedByStock" />
        </ng-template>
    </p-dialog>
    <p-dialog [(visible)]="confirmInvoiceDialogVisible" [style]="{ width: '400px' }" header="Confirm Invoice" [modal]="true">
        <ng-template pTemplate="content">
            <div class="text-center">
                <p>
                    Printing invoice will change the order status to <b>INV</b>.<br />
                    Are you sure you want to continue?
                </p>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <p-button label="Cancel" icon="pi pi-times" text (click)="confirmInvoiceDialogVisible = false"></p-button>
            <p-button label="OK" icon="pi pi-check" (click)="confirmInvoiceDialogVisible = false; generateInvoice()"></p-button>
        </ng-template>
    </p-dialog>

    <p-dialog
        [(visible)]="wh101OrderTypeWarningVisible"
        [modal]="true"
        [style]="{ width: '26rem', maxWidth: '95vw' }"
        header="Order type warning"
        [closable]="true"
        (onHide)="onWh101OrderTypeWarningOk()"
    >
        <div style="font-size: 15px; line-height: 1.45; word-break: break-word;">
            {{ wh101OrderTypeWarningMessage }}
        </div>
        <ng-template pTemplate="footer">
            <p-button label="OK" icon="pi pi-check" (onClick)="onWh101OrderTypeWarningOk()"></p-button>
        </ng-template>
    </p-dialog>
</div>

<app-ar-statement-form
  [(visible)]="customerDialogVisible"
  [prefillCustomer]="{
    customerNumber: selectedCustomerNumber,
    customerName: selectedCustomerName
  }"
  (submitAR)="handleARSubmit($event)">
</app-ar-statement-form>
   <p-toast />



